<div [formGroup]="templateForm" *ngIf="templateForm" class="main-container">
    <p-confirmDialog header="Delete Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    <p-toast></p-toast>
    <div>
        Name
        <input pInputText formControlName="name">
        Language: {{selectedTemplate.language.name}}
    </div>
    <div>
        Subject:
    </div>
    <div>
        <input pInputText formControlName="subject" class="subject-input">
    </div>
    <div>
        <span>
            Background:
        </span>
        <p-dropdown placeholder="None" [options]="colors" appendTo="body" [showClear]="true" (onChange)="updateBackgroundColor($event.value)">
            <ng-template pTemplate="selectedItem">
                <div class="color-label-container"  *ngIf="templateForm.value.backgroundColor">
                    <div [style]="{backgroundColor: templateForm.value.backgroundColor, width:'20px', height: '20px'}"></div>
                    <span>
                        {{templateForm.value.backgroundColor}}
                    </span>
                </div>
            </ng-template>
            <ng-template let-color pTemplate="item">
                <div class="color-label-container">
                    <div [style]="{backgroundColor: color, width:'20px', height: '20px'}"></div>
                    <span>
                        {{color}}
                    </span>
                </div>
            </ng-template>
        </p-dropdown>
        <input pInputText formControlName="backgroundColor">
    </div>
    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
    <p-button label="Submit" (onClick)="updateTemplate()" [disabled]="processing"></p-button>
    <p-button (onClick)="deleteTemplate()" label="Delete" styleClass="p-button-danger"></p-button>
</div>
